import { render } from "./Agreement_ios.vue?vue&type=template&id=45cf1d80&scoped=true"
import script from "./Agreement_ios.vue?vue&type=script&lang=js"
export * from "./Agreement_ios.vue?vue&type=script&lang=js"

import "./Agreement_ios.vue?vue&type=style&index=0&id=45cf1d80&scoped=true&lang=less"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cf1d80"]])

export default __exports__